import React from 'react';
import Whole from '../whole';

export default function () {
  return <Whole noFixedVideo noExitIntent variant="ad" />;
}
